'use client';

import { useParams } from 'next/navigation';
import useCmsPage from '@hooks/useCmsPage';
import ErrorComponent from '@molecules/ErrorComponent/ErrorComponent';
import Page from '@organisms/Page/Page';

const ProductPageClient = () => {
  const params = useParams<{ name: string }>();
  const code = params?.name?.split('-').at(-1);
  const { cmsPage, error, isLoading } = useCmsPage(undefined, 'ProductPage', code);

  if (!isLoading && error) return <ErrorComponent errorCode={404} />;

  return <Page cmsPage={cmsPage} />;
};

export default ProductPageClient;
